document.addEventListener('DOMContentLoaded', function () {
  class YGVideoList extends HTMLElement {
    constructor() {
      super();
      window.addEventListener('resize', () => {
        // 在窗口大小发生变化时执行的操作
        this.initStyle();
        this.toggleVideo();
      });

      window.dispatchEvent(new Event('resize'));
    }
    initStyle() {
      let windowWidth = window.innerWidth;

      if (windowWidth > 700) {
        let videoHeight =
          this.querySelector('.yg-main-video').getBoundingClientRect().height;
        this.querySelector('.yg-video-list').style.height = `${videoHeight}px`;
      } else {
        let more = this.querySelector('.yg-more');
        let less = this.querySelector('.yg-less');
        let videoListBox = this.querySelector('.yg-video-list');
        let videoListLength = this.querySelectorAll(
          '.yg-video-block__image'
        ).length;
        let videoHeight = this.querySelector(
          '.yg-video-block__image'
        ).getBoundingClientRect().height;
        let showLength = 3;

        videoListBox.style.height = `${showLength * videoHeight + (showLength - 1) * 20}px`;

        more.addEventListener('click', () => {
          showLength += 3;
          let show =
            showLength >= videoListLength ? videoListLength : showLength;

          videoListBox.style.height = `${show * videoHeight + (show - 1) * 20}px`;
          if (show == videoListLength) {
            more.style.display = 'none';
            less.style.display = 'flex';
          }
        });

        less.addEventListener('click', () => {
          showLength = 3;
          videoListBox.style.height = `${showLength * videoHeight + (showLength - 1) * 20}px`;

          less.style.display = 'none';
          more.style.display = 'flex';
        });
      }
    }
    toggleVideo() {
      let videoList = this.querySelectorAll('.yg-video-block__image');
      let mainVideo = this.querySelector('.yg-main-video');
      let dialog = this.querySelector('.yg-video-block__dialog');
      let windowWidth = window.innerWidth;

      videoList.forEach(function (video) {
        video.addEventListener('click', function (e) {
          if (e.target.classList.contains('yg-video-block__open')) {
            let template = video.querySelector('.yg-video-block__template');
            if (windowWidth > 767) {
              mainVideo.innerHTML = template.innerHTML;
            } else {
              dialog.innerHTML = template.innerHTML;
              document.querySelector('body').style.overflowY = 'hidden';
              dialog.showModal();
            }
            videoList.forEach(function (video) {
              video.classList.remove('active');
            });
            video.classList.add('active');
          }
        });
      });

      dialog.addEventListener('click', function (e) {
        if (e.target.classList.contains('yg-video-block__dialog')) {
          document.querySelector('body').style.overflowY = 'auto';
          videoList.forEach(function (video) {
            video.classList.remove('active');
          });
          dialog.close();
        }
      });
    }
  }

  if (!window.customElements.get('yg-video-list')) {
    window.customElements.define('yg-video-list', YGVideoList);
  }

  class YGToggle extends HTMLElement {
    constructor() {
      super();
    }

    updateContentHeight() {
      const scrollHeight = this.content.scrollHeight;
      this.content.style.maxHeight = scrollHeight + 'px';
    }

    connectedCallback() {
      this.button = this.querySelector('.yg-toggle-button');
      this.content = this.querySelector('.yg-toggle-content');
      if (this.button && this.content) {
        this.button.addEventListener('click', () => {
          const isActive = this.button.classList.contains('active');
          this.button.classList.toggle('active', !isActive);

          console.log(this.button);
          this.content.classList.toggle('open', !isActive);
          if (!isActive) {
            const scrollHeight = this.content.scrollHeight;
            this.content.style.maxHeight = scrollHeight + 'px';
          } else {
            this.content.style.maxHeight = '0px';
          }
        });
        if (this.content.classList.contains('open')) {
          this.content.style.maxHeight = this.content.scrollHeight + 'px';
        }
      }

      window.addEventListener('resize', () => {
        if (this.content.classList.contains('open')) {
          this.updateContentHeight();
        }
      });
    }
  }

  if (!customElements.get('yg-toggle')) {
    customElements.define('yg-toggle', YGToggle);
  }

  class YGBuyItNow extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      // 这里放置初始化逻辑
      let _this = this;
      let $button = _this.querySelector('.yg-buy-it-now-button');
      $button.addEventListener('click', () => _this.buttonClick());
    }
    buttonClick() {
      // 这里放置自定义逻辑
      let buyBtn =
        this.querySelector(
          '.shopify-payment-button .shopify-payment-button__more-options'
        ) ||
        this.querySelector(
          '.shopify-payment-button .shopify-payment-button__button'
        );
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow);
  }

  class YGNavAddToCart extends HTMLElement {
    constructor() {
      super();
      this.querySelector('button').addEventListener('click', () =>
        this.handleClick()
      );
    }
    handleClick() {
      const mainSubmit = document.querySelector(
        'product-form .product-form__submit, .product-form__buttons .product-form__submit'
      );
      if (mainSubmit) {
        mainSubmit.click();
      }
    }
  }
  if (!window.customElements.get('yg-nav-add-to-cart')) {
    window.customElements.define('yg-nav-add-to-cart', YGNavAddToCart);
  }

  class YGNavBuyNow extends HTMLElement {
    constructor() {
      super();
      this.querySelector('button').addEventListener('click', () =>
        this.handleClick()
      );
    }
    handleClick() {
      const mainBuyNow = document.querySelector(
        'yg-buy-it-now .yg-buy-it-now-button'
      );
      if (mainBuyNow) {
        mainBuyNow.click();
      }
    }
  }
  if (!window.customElements.get('yg-nav-buy-now')) {
    window.customElements.define('yg-nav-buy-now', YGNavBuyNow);
  }
});
document.addEventListener('DOMContentLoaded', function () {
  class YGVideoSwiper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initSwiper();
    }
    initSwiper() {
      const swiper = new Swiper(this, {
        slidesPerView: 1.1,
        spaceBetween: 20,
        loop: true,
        centeredSlides: true,
        fadeEffect: {
          crossFade: true
        },
        autoplay:
          this.getAttribute('data-enable-autoplay') === 'true'
            ? {
                delay:
                  parseInt(this.getAttribute('data-autoplay-delay')) * 1000,
                stopOnLastSlide: false,
                disableOnInteraction: true
              }
            : false,
        breakpoints: {
          768: {
            slidesPerView: 1.7,
            spaceBetween: 32
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'progressbar',
          progressbarOpposite: false
        }
      });
    }
  }

  if (!window.customElements.get('yg-video-swiper')) {
    window.customElements.define('yg-video-swiper', YGVideoSwiper);
  }

  class YGAccordion extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector('.yg-accordion-header');
      const content = this.querySelector('.yg-accordion-content');
      const trueHeight = content.scrollHeight;
      content.style.setProperty('--true-height', `${trueHeight}px`);
      header.addEventListener('click', () => {
        this.classList.toggle('yg-accordion-open');
      });
    }
  }

  if (!window.customElements.get('yg-accordion')) {
    window.customElements.define('yg-accordion', YGAccordion);
  }

  // YG Variant Image Picker
  class YGVariantImagePicker extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.productId = this.dataset.productId;
      this.sectionId = this.dataset.sectionId;
      this.inputs = this.querySelectorAll('input[type="radio"]');
      this.selectedLabel = this.querySelector(
        `#${this.sectionId}-${this.productId}-selected-variant`
      );
      this.productCard = this.closest('.product-card');

      this.init();
    }

    init() {
      this.inputs.forEach((input) => {
        input.addEventListener('change', this.handleVariantChange.bind(this));
      });
    }

    handleVariantChange(event) {
      const input = event.target;
      const variantId = input.dataset.variantId;
      const variantValue = input.dataset.variantValue;
      const variantImage = input.dataset.variantImage;
      const variantPrice = input.dataset.variantPrice;
      const variantComparePrice = input.dataset.variantComparePrice;
      const variantAvailable = input.dataset.variantAvailable === 'true';

      // 更新选中的变体名称
      if (this.selectedLabel) {
        this.selectedLabel.textContent = variantValue;
      }

      // 更新产品卡片的主图
      if (variantImage && this.productCard) {
        const mainImage = this.productCard.querySelector(
          '.product-card__media a img'
        );
        if (mainImage) {
          mainImage.src = variantImage;
          mainImage.srcset = variantImage;
        }
      }

      // 更新价格
      if (this.productCard) {
        const priceContainer = this.productCard.querySelector('.price');
        const priceRegular = this.productCard.querySelector('.price__regular');
        let priceSale = this.productCard.querySelector('.price__sale');

        if (priceRegular) {
          const formattedPrice = this.formatMoney(variantPrice);
          priceRegular.innerHTML = formattedPrice;
        }

        // 处理促销价格
        if (
          variantComparePrice &&
          parseInt(variantComparePrice) > parseInt(variantPrice)
        ) {
          // 有促销价格
          if (priceContainer) {
            priceContainer.classList.add('price--on-sale');
          }

          if (priceSale) {
            const formattedComparePrice = this.formatMoney(variantComparePrice);
            priceSale.innerHTML = formattedComparePrice;
          } else if (priceRegular) {
            // 如果没有 price__sale 元素，创建一个
            const salePriceSpan = document.createElement('span');
            salePriceSpan.className =
              'price__sale inline-flex items-center h-auto relative';
            salePriceSpan.innerHTML = this.formatMoney(variantComparePrice);
            priceRegular.parentNode.appendChild(salePriceSpan);
          }
        } else {
          // 没有促销价格，移除促销样式
          if (priceContainer) {
            priceContainer.classList.remove('price--on-sale');
          }
          if (priceSale) {
            priceSale.remove();
          }
        }
      }

      // 更新快速添加按钮的变体ID
      if (this.productCard) {
        const quickAddForms = this.productCard.querySelectorAll(
          'form[is="product-form"]'
        );
        quickAddForms.forEach((form) => {
          const hiddenInput = form.querySelector('input[name="id"]');
          if (hiddenInput) {
            hiddenInput.value = variantId;
          }

          const submitButton = form.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.dataset.variantId = variantId;
            if (!variantAvailable) {
              submitButton.disabled = true;
              const btnText = submitButton.querySelector('.btn-text span');
              if (btnText) {
                btnText.textContent = btnText.dataset.soldOut || '售罄';
              }
            } else {
              submitButton.disabled = false;
              const btnText = submitButton.querySelector('.btn-text span');
              if (btnText && btnText.dataset.addToCart) {
                btnText.textContent = btnText.dataset.addToCart;
              }
            }
          }
        });
      }

      // 触发自定义事件
      this.dispatchEvent(
        new CustomEvent('variant-change', {
          bubbles: true,
          detail: {
            variantId,
            variantValue,
            variantImage,
            variantPrice,
            variantComparePrice,
            variantAvailable
          }
        })
      );
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, theme.moneyFormat || '{{amount}}');
      }
      return (cents / 100).toFixed(2);
    }
  }

  if (!window.customElements.get('yg-variant-image-picker')) {
    window.customElements.define(
      'yg-variant-image-picker',
      YGVariantImagePicker
    );
  }

  // YG Featured Collection - Learn More Toggle
  class YGFeaturedCollection extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.showLearnMore = this.dataset.showLearnMore === 'true';

      if (this.showLearnMore) {
        this.learnMoreBtn = this.querySelector('[data-learn-more-toggle]');
        this.productGrid = this.querySelector('[data-product-grid]');

        if (this.learnMoreBtn && this.productGrid) {
          this.learnMoreBtn.addEventListener(
            'click',
            this.handleToggle.bind(this)
          );
        }
      }
    }

    handleToggle() {
      const isExpanded = this.learnMoreBtn.classList.contains('expanded');

      if (isExpanded) {
        // 收缩
        this.productGrid.classList.add('collapsed');
        this.learnMoreBtn.classList.remove('expanded');
        this.learnMoreBtn.querySelector('.learn-more-text').textContent =
          'Learn More';
      } else {
        // 展开
        this.productGrid.classList.remove('collapsed');
        this.learnMoreBtn.classList.add('expanded');
        this.learnMoreBtn.querySelector('.learn-more-text').textContent =
          'Show Less';
      }
    }
  }

  if (!window.customElements.get('yg-featured-collection')) {
    window.customElements.define(
      'yg-featured-collection',
      YGFeaturedCollection
    );
  }
});
